<ui-map-with-sidebar
    [mapItems]="(mapItems$ | async) ?? fallbackMapItems"
    [mapAreas]="mapAreas$ | async"
    [popupContentComponentType]="popupContentComponentType"
    (reloadMapData)="reloadMapData()"
>
    <ui-filter-mapper filters/>
    <ui-project-list-item-details map-item-details
        [mapItem]="(detailViewItem$ | async) ?? undefined"
        (mapItemTriggeredById)="openMapItemById($event)"
    />
</ui-map-with-sidebar>
